import { defineStore } from "pinia";

import {
  TOrganizationPerimeter,
  TSitePerimeter,
} from "@/data/api/kili/consumption/types/user-organization-perimeter.type";

interface IState {
  organizationPerimeter: TOrganizationPerimeter[] | null;
  insights: {
    isDsoConsumptionInfosVisible: boolean;
    isDevicesTotalConsumptionInfosVisible: boolean;
  };
}

function flattenOrganizationSites(organization: TOrganizationPerimeter): TSitePerimeter[] {
  return organization.sites.concat(organization.children.flatMap(flattenOrganizationSites));
}

export const useDashboardStore = defineStore("dashboard", {
  state: (): IState => {
    return {
      organizationPerimeter: null,
      insights: {
        isDsoConsumptionInfosVisible: false,
        isDevicesTotalConsumptionInfosVisible: false,
      },
    };
  },
  actions: {
    setOrganizationPerimeter(organizationPerimeter: TOrganizationPerimeter[] | null) {
      if (!organizationPerimeter?.length) {
        this.organizationPerimeter = null;
        return;
      }

      this.organizationPerimeter = organizationPerimeter;
    },
    showDsoConsumptionInfos() {
      this.insights.isDsoConsumptionInfosVisible = true;
    },
    showDevicesTotalConsumptionInfos() {
      this.insights.isDevicesTotalConsumptionInfosVisible = true;
    },
  },
  getters: {
    sitePerimeter(): TSitePerimeter[] | null {
      if (!this.organizationPerimeter) return null;
      return this.organizationPerimeter.flatMap(flattenOrganizationSites);
    },
  },
});
